import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=74015e16&scoped=true"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=74015e16&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74015e16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74015e16')) {
      api.createRecord('74015e16', component.options)
    } else {
      api.reload('74015e16', component.options)
    }
    module.hot.accept("./Function.vue?vue&type=template&id=74015e16&scoped=true", function () {
      api.rerender('74015e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/components/Function.vue"
export default component.exports